module.exports = __webpack_public_path__ + "static/media/rating_footer.9d8a7f33.png";